import emptyState from "./emptyState";
import { actionTypes } from "./actions";
import { immutableSet } from "../../../utils/immutable";
import { IAction } from "../../../models/Action";
import { compose } from "redux";

import {
  SERVICE_REQUEST_IDENTIFIER,
  LOADER_IDENTIFIER,
  LIST_IDENTIFIER,
} from "./constants";
import { IResponseState } from "../../../components/Modals/ResponseModal/module/constants";

const { TYPES, FIELDS, REQUEST_STATE, APPLICATIONS, BAOS } =
  SERVICE_REQUEST_IDENTIFIER;

const ACTION_HANDLERS = {
  [actionTypes.TYPE_REQUEST_SUCCESS]: (state: any, action: any) => {
    let tempRes;
    if (action.payload.length > 0) {
      tempRes = action.payload.sort((a: any, b: any) => {
        if (a.displayOrder > b.displayOrder) {
          return 1;
        } else if (a.displayOrder < b.displayOrder) {
          return -1;
        } else {
          return 0;
        }
      });
    }

    return immutableSet([TYPES, LIST_IDENTIFIER], tempRes, state);
  },
  [actionTypes.TYPE_REQUEST_FAILURE]: (state: any, action: any) => {
    return immutableSet([TYPES, LIST_IDENTIFIER], [], state);
  },

  [actionTypes.FIELD_REQUEST]: (state: any, action: any) =>
    immutableSet([LOADER_IDENTIFIER], true, state),
  [actionTypes.FIELD_REQUEST_SUCCESS]: (state: any, action: any) => {
    return compose(
      immutableSet([LOADER_IDENTIFIER], false),
      immutableSet([FIELDS, LIST_IDENTIFIER], action.payload)
    )(state);
  },
  [actionTypes.FIELD_REQUEST_FAILURE]: (state: any, action: any) => {
    return compose(
      immutableSet([LOADER_IDENTIFIER], false),
      immutableSet([FIELDS, LIST_IDENTIFIER], [])
    )(state);
  },

  [actionTypes.SEND_REQUEST]: (state: any, action: any) =>
    immutableSet([REQUEST_STATE], IResponseState.PENDING, state),
  [actionTypes.SEND_REQUEST_SUCCESS]: (state: any, action: any) =>
    immutableSet([REQUEST_STATE], IResponseState.SUCCESS, state),
  [actionTypes.SEND_REQUEST_FAILURE]: (state: any, action: any) =>
    immutableSet([REQUEST_STATE], IResponseState.ERROR, state),

  [actionTypes.SEND_NEW_API_REQUEST]: (state: any, action: any) =>
    immutableSet([REQUEST_STATE], IResponseState.PENDING, state),
  [actionTypes.SEND_NEW_API_REQUEST_SUCCESS]: (state: any, action: any) =>
    immutableSet([REQUEST_STATE], IResponseState.SUCCESS, state),
  [actionTypes.SEND_NEW_API_REQUEST_FAILURE]: (state: any, action: any) =>
    immutableSet([REQUEST_STATE], IResponseState.ERROR, state),

  [actionTypes.GET_SERVICE_RERQUEST_APPLICATIONS]: (state: any, action: any) =>
    immutableSet([LOADER_IDENTIFIER], true, state),
  [actionTypes.GET_SERVICE_RERQUEST_APPLICATIONS_SUCCESS]: (
    state: any,
    action: any
  ) => {
    return compose(
      immutableSet([LOADER_IDENTIFIER], false),
      immutableSet([APPLICATIONS, LIST_IDENTIFIER], action.payload)
    )(state);
  },
  [actionTypes.GET_SERVICE_RERQUEST_APPLICATIONS_FAILURE]: (
    state: any,
    action: any
  ) => {
    return compose(
      immutableSet([LOADER_IDENTIFIER], false),
      immutableSet([APPLICATIONS, LIST_IDENTIFIER], [])
    )(state);
  },

  [actionTypes.GET_SERVICE_RERQUEST_BAO]: (state: any, action: any) =>
    immutableSet([LOADER_IDENTIFIER], true, state),
  [actionTypes.GET_SERVICE_RERQUEST_BAO_SUCCESS]: (state: any, action: any) => {
    return compose(
      immutableSet([LOADER_IDENTIFIER], false),
      immutableSet([BAOS, LIST_IDENTIFIER], action.payload)
    )(state);
  },
  [actionTypes.GET_SERVICE_RERQUEST_BAO_FAILURE]: (state: any, action: any) => {
    return compose(
      immutableSet([LOADER_IDENTIFIER], false),
      immutableSet([BAOS, LIST_IDENTIFIER], action.payload)
    )(state);
  },
};

export default function communicationReducer(
  state = emptyState,
  action: IAction
) {
  if (
    action &&
    action.type === "@@router/LOCATION_CHANGE" &&
    action.payload.location.pathname === "/welcome"
  ) {
    return emptyState;
  }
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
